import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-card-heading",
  templateUrl: "./card-heading.component.html",
  styleUrls: ["./card-heading.component.scss"],
})
export class CardHeadingComponent implements OnInit {
  @Input() heading: string;
  @Input() isInfoAvailable: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
